<template>
    <div ref="chart"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
    name: "ChartMap",
    data() {
        return {
            chartObj: null,
        };
    },
    mounted() {
        window.addEventListener("resize", () => {
            if (this.chartObj) {
                this.chartObj.resize();
            }
        });
    },
    methods: {
        setData(opt, notip) {
            if (this.chartObj) {
                this.chartObj.clear();
                this.chartObj.dispose();
            }
            if (!notip) {
                opt.tooltip = {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999",
                        },
                    },
                };
            }
            let chart = echarts.init(this.$refs.chart);
            chart.setOption(opt);
            this.chartObj = chart;
        },
        noData() {
            if (this.chartObj) {
                this.chartObj.clear();
                this.chartObj.dispose();
            }
            let option = {
                grid: {
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                },
                xAxis: {
                    type: "category",
                    data: [],
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        data: [],
                        type: "bar",
                    },
                ],
            };
            let chart = echarts.init(this.$refs.chart);
            chart.setOption(option);
            chart.showLoading({
                text: "暂无数据",
                showSpinner: false,
                fontSize: 14,
                textColor: "#000",
            });
            this.chartObj = chart;
        },
    },
};
</script>
